"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiftProductAuthoringService = exports.GiftProductService = exports.GiftConfig = void 0;
const effect_1 = require("effect");
const HttpClient = __importStar(require("@effect/platform/HttpClient"));
const productAuthoring_1 = require("../productAuthoring");
const requests_1 = require("./gift/requests");
const resolvers_1 = require("./gift/resolvers");
const service_1 = require("./service");
class GiftConfig extends effect_1.Context.Tag('@fixtuur/backpack/GiftConfig')() {
}
exports.GiftConfig = GiftConfig;
exports.GiftProductService = effect_1.Layer.effect(service_1.ProductService, effect_1.Effect.gen(function* () {
    const http = yield* HttpClient.HttpClient;
    const { giftUrl } = yield* GiftConfig;
    const ProductsResolver = (0, resolvers_1.getProductsResolver)(http);
    const getByTenant = (tenantId) => effect_1.Effect.andThen(giftUrl, giftUrl => {
        return effect_1.Effect.request((0, requests_1.GetProducts)({ tenant: tenantId, baseUrl: giftUrl }), ProductsResolver);
    });
    const ProductByIdResolver = (0, resolvers_1.getProductByIdResolver)(http);
    const getById = (productId, tenantId) => effect_1.Effect.andThen(giftUrl, giftUrl => effect_1.Effect.request((0, requests_1.GetProduct)({
        tenant: tenantId,
        productId,
        baseUrl: giftUrl,
    }), ProductByIdResolver));
    const ProductsByGroupingCodeResolver = (0, resolvers_1.getProductsByGroupingCodeResolver)(http);
    const getByGroupingCode = (tenantId, groupingCode) => effect_1.Effect.andThen(giftUrl, giftUrl => {
        return effect_1.Effect.request((0, requests_1.GetProductsByGroupingCode)({
            tenant: tenantId,
            groupingCode,
            baseUrl: giftUrl,
        }), ProductsByGroupingCodeResolver);
    });
    return {
        getByTenant,
        getById,
        getByGroupingCode,
    };
}));
exports.GiftProductAuthoringService = effect_1.Layer.effect(productAuthoring_1.ProductAuthoringService, effect_1.Effect.gen(function* () {
    const http = yield* HttpClient.HttpClient;
    const { giftUrl } = yield* GiftConfig;
    const PatchProductByIdResolver = (0, resolvers_1.patchProductsResolver)(http);
    const patch = (tenantId, products, token) => effect_1.Effect.andThen(giftUrl, giftUrl => effect_1.Effect.request((0, requests_1.PatchProducts)({
        tenant: tenantId,
        products,
        baseUrl: giftUrl,
        token,
    }), PatchProductByIdResolver));
    const ValidateProductResolver = (0, resolvers_1.validateProductsResolver)(http);
    const validate = (tenantId, products) => effect_1.Effect.andThen(giftUrl, giftUrl => effect_1.Effect.request((0, requests_1.ValidateProducts)({
        tenant: tenantId,
        products,
        baseUrl: giftUrl,
    }), ValidateProductResolver));
    const GetAttributesResolver = (0, resolvers_1.getAttributesResolver)(http);
    const getAttributes = (types) => effect_1.Effect.andThen(giftUrl, giftUrl => effect_1.Effect.request((0, requests_1.GetAttributes)({ types, baseUrl: giftUrl }), GetAttributesResolver));
    return { patch, validate, getAttributes };
}));
